import type { HotelIngredient } from '@apps/main/modules/recipe/ingredients';

import {
  trackAccommodationFiltersRulesFilters,
  trackAccommodationFiltersAccommodationType,
  trackAccommodationFiltersStarsRate,
  trackAccommodationFiltersBoardBasisFilter,
  trackAccommodationFiltersAmenitiesFilters,
  trackAccommodationFiltersExperienceFilters,
} from '@libs/google-analytics-events';
import type {
  AccommodationRule,
  StarsRatingFilter,
  BoardBasisFilter,
  AmenitiesFilter,
  ExperienceFilter,
  AccommodationProductType,
} from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';
import { toggleValue } from '@libs/utils';

export function setFilterText(
  filterText: string,
  currentHotel: HotelIngredient,
  ingredientType: IngredientType
): void {
  if (ingredientType === IngredientType.Hotel) {
    currentHotel.filters.filterText = filterText;
  } else {
    currentHotel.filters.activitiesFilterText = filterText;
  }
}

export function toggleFreeCancellation(
  hotelRule: AccommodationRule,
  currentHotel: HotelIngredient
): void {
  const isAddingHotelRule = !currentHotel.filters.selectedHotelRules.some(
    (selectedRuleFilter) => selectedRuleFilter === hotelRule
  );

  trackAccommodationFiltersRulesFilters(hotelRule, isAddingHotelRule);
  toggleValue(hotelRule, currentHotel.filters.selectedHotelRules);
}

export function toggleHotelType(
  hotelType: AccommodationProductType,
  currentHotel: HotelIngredient
): void {
  const isAddingHotelType =
    !currentHotel.filters.selectedHotelTypes.includes(hotelType);

  trackAccommodationFiltersAccommodationType(hotelType, isAddingHotelType);

  toggleValue(hotelType, currentHotel.filters.selectedHotelTypes);
}

export function setStarsRating(
  star: StarsRatingFilter,
  currentHotel: HotelIngredient
): void {
  trackAccommodationFiltersStarsRate(star);
  currentHotel.filters.starRating = star;
}

export function toggleBoardBasisFilter(
  boardBasisFilter: BoardBasisFilter,
  currentHotel: HotelIngredient
): void {
  const isAddingBoardBasisFilter =
    !currentHotel.filters.boardBasis.includes(boardBasisFilter);
  trackAccommodationFiltersBoardBasisFilter(
    boardBasisFilter,
    isAddingBoardBasisFilter
  );
  toggleValue(boardBasisFilter, currentHotel.filters.boardBasis);
}

export function toggleAmenitiesFilter(
  amenitiesFilter: AmenitiesFilter,
  currentHotel: HotelIngredient
): void {
  const isAddingAmenitiesFilter =
    !currentHotel.filters.selectedAmenitiesFilters.includes(amenitiesFilter);
  trackAccommodationFiltersAmenitiesFilters(
    amenitiesFilter,
    isAddingAmenitiesFilter
  );
  toggleValue(amenitiesFilter, currentHotel.filters.selectedAmenitiesFilters);
}

export function toggleExperienceFilter(
  experienceFilter: ExperienceFilter,
  currentHotel: HotelIngredient
): void {
  const isAddingExperienceFilter =
    !currentHotel.filters.selectedExperienceFilters.includes(experienceFilter);
  trackAccommodationFiltersExperienceFilters(
    experienceFilter,
    isAddingExperienceFilter
  );
  toggleValue(experienceFilter, currentHotel.filters.selectedExperienceFilters);
}
